import { toast as sonnerToast } from 'sonner';
import { IToastIcon, ToastIcon } from './toast-icon';
import { Text, Note } from '../text';
import { Icon } from '../icon';

export interface IToastPayload {
  title: string;
  message?: string;
}

interface IToastOptions {
  type: IToastIcon;
  [key: string]: unknown;
}

export function createToast({ title, message }: IToastPayload, options: IToastOptions) {
  const description = message || '';
  const duration = typeof options?.duration === 'number' ? options.duration : 2000;

  return sonnerToast.custom(
    (toastId) => (
      <div className="flex min-w-[320px] max-w-[520px] items-center justify-between gap-3 rounded-full bg-white p-3 shadow-lg">
        <div className="flex items-center gap-3">
          <ToastIcon type={options.type} />
          <div className="flex flex-col gap-0.5">
            <Text type="m" className="font-semibold">
              {title}
            </Text>
            {description ? (
              <Note type="s" className="line-clamp-2 break-words">
                {description}
              </Note>
            ) : null}
          </div>
        </div>

        <button
          onClick={() => sonnerToast.dismiss(toastId)}
          className="hover:bg-bgGrey active:bg-inputActive flex aspect-square w-10 items-center justify-center rounded-full">
          <Icon type="close" />
        </button>
      </div>
    ),
    {
      duration,
      className: '!bg-transparent !shadow-none !border-0 !p-0',
    },
  );
}

function useToast() {
  return createToast;
}

export { useToast };
